import { CreateNewProps } from '../CreateNew/typings'
import { useActions as useNewActions } from '../CreateNew/hooks'
import { useActions as useMatchActions } from '../Match/hooks'
import { MatchCreateNewProps } from '../typings'
import { useMemo } from 'react'

type Props = CreateNewProps &
  MatchCreateNewProps & {
    tab: number
  }

export function useCreateMatchSave(props: Props) {
  const { tab } = props
  const { saving: savingNew, onSave: onSaveNew } = useNewActions({
    ...props,
    detail: true,
  })

  const {
    onSave: onSaveMatch,
    state,
    dispatch,
    disableSave: savingMatch,
    billToLocation,
    label,
  } = useMatchActions({ ...props })

  const disableSave = useMemo(() => {
    if (tab === 0) {
      return savingMatch
    }
    return savingNew || props?.anyInvalid
  }, [tab, savingMatch, savingNew, props?.anyInvalid])

  function onSave() {
    if (tab === 0) {
      onSaveMatch()
    } else {
      {
        onSaveNew()
      }
    }
  }

  return { billToLocation, disableSave, dispatch, label, onSave, state }
}
